var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 41,
    viewBox: "0 0 194 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.733 16.3203H135.357V32.7061H139.733V16.3203Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8297 13.7815V9.40625H13.588H9.21094V13.7815V18.8669V23.2422V28.3276V32.7029H13.588H26.8297V28.3276H13.588V23.2422H26.2248V18.8669H13.588V13.7815H26.8297Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.801 13.7815V9.40625H172.559H168.184V13.7815V18.8669V23.2422V28.3276V32.7029H172.559H185.801V28.3276H172.559V23.2422H185.196V18.8669H172.559V13.7815H185.801Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6129 9.42969H58.9941V13.8049H76.6129V9.42969Z",
    fill: "#F89C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6129 28.3516H58.9941V32.7268H76.6129V28.3516Z",
    fill: "#F89C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6129 18.8906H58.9941V23.2659H76.6129V18.8906Z",
    fill: "#F89C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0282 27.1415L36.3725 9.45312H30.6465L40.1428 32.7033H46.008L55.317 9.45312H49.5928L43.0282 27.1415Z",
    fill: "#383838"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.656 17.226C100.656 13.0845 97.1858 9.72632 92.9069 9.72632L85.5196 9.70312H81.1426V13.9089V33.0015H85.5178V13.9089H89.8574H92.848C93.3512 13.9089 93.8312 14.0088 94.2719 14.1837C95.6958 14.7511 96.704 16.1393 96.704 17.7649C96.704 19.7955 95.1337 21.4549 93.1442 21.6066C93.0853 21.6137 93.0264 21.6155 92.9657 21.6173C92.9265 21.6191 92.8872 21.6209 92.848 21.6209H89.9395V25.4269L96.2579 32.9569H101.914L95.2444 25.0129C98.3813 23.8763 100.656 20.5806 100.656 17.226Z",
    fill: "#383838"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.842 17.226C129.842 13.0845 126.371 9.72632 122.093 9.72632L114.705 9.70312H110.33V13.9089V33.0015H114.705V13.9089H119.045H122.035C122.539 13.9089 123.019 14.0088 123.459 14.1837C124.883 14.7511 125.891 16.1393 125.891 17.7649C125.891 19.7955 124.321 21.4549 122.332 21.6066C122.273 21.6137 122.214 21.6155 122.153 21.6173C122.114 21.6191 122.075 21.6209 122.035 21.6209H119.127V25.4269L125.445 32.9569H131.102L124.432 25.0129C127.567 23.8763 129.842 20.5806 129.842 17.226Z",
    fill: "#383838"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.181 14.9811C139.682 14.6267 140.611 13.1227 140.257 11.6217C139.902 10.1208 138.398 9.19136 136.897 9.54578C135.396 9.90019 134.467 11.4042 134.821 12.9052C135.176 14.4061 136.68 15.3356 138.181 14.9811Z",
    fill: "#F89C1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.198 15.8924C150.198 14.5416 151.446 13.6637 153.646 13.6637C156.139 13.6637 158.779 14.4399 160.758 16.1297L163.654 12.5485C161.235 10.4876 158.009 9.40625 154.122 9.40625C148.366 9.40625 144.845 12.5146 144.845 16.2635C144.845 24.7428 158.924 22.0056 158.924 25.9241C158.924 27.2409 157.568 28.424 154.67 28.424C151.298 28.424 148.621 27.0054 146.897 25.3495L144.037 29.0984C146.346 31.2272 149.72 32.6797 154.451 32.6797C161.014 32.6797 164.24 29.5713 164.24 25.4512C164.241 17.0415 150.198 19.4397 150.198 15.8924Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2988aa0c57eee4299338cd3e493e7a45.svg";
export { ForwardRef as ReactComponent };